import type { UploadChannel } from './upload';

/**
 * Which channel a workspace job's files and requests go through. On a job's route the mount's
 * `engineOrigin` is already the job's channel (`/v1/jobs/{id}`). On the new-job route it is the
 * tenant's (`/v1`), which has no `/import`; a job the workbench creates there becomes a Paige job
 * through `POST /v1/jobs`, and from then on its own channel is the one to use, so the adapter
 * remembers the Paige id the API answered with.
 */
export interface JobChannels {
  /** The channel for a workspace job: its own when Paige knows it, else the mount's. */
  channelFor: (workspaceJobId: string) => UploadChannel;
  /** A workspace job the API just made a Paige job of. */
  remember: (workspaceJobId: string, paigeJobId: string) => void;
}

export function jobChannels(
  engineOrigin: string,
  tenant: string | undefined,
  apiOrigin: string | undefined,
): JobChannels {
  const created = new Map<string, string>();
  return {
    channelFor: (workspaceJobId) => {
      const paigeJobId = created.get(workspaceJobId);
      return {
        engineOrigin: apiOrigin && paigeJobId ? `${apiOrigin}/jobs/${paigeJobId}` : engineOrigin,
        tenant,
      };
    },
    remember: (workspaceJobId, paigeJobId) => created.set(workspaceJobId, paigeJobId),
  };
}
